import axios from "axios";
import Constants from "./constant";
import moment from "moment";
import CryptoJS from "crypto-js";

export const axiosClient = axios.create({
    baseURL: `${Constants.env.lambdaApiServer}`,
});

let getCurrentDate = () => {
    return moment().utc().format("YYYY-MM-DD");
};
export const getAuthToken = (child_id = undefined, parent = undefined) => {
    const saltKey = "!foot@prints#education#";
    let token = getCurrentDate() + "_" + saltKey;
    console.log("Generating Token ...");

    if (child_id && parent) {
        token =
            child_id + "_" + getCurrentDate() + "_" + parent + "_" + saltKey;
    }
    // return crypto.createHash("md5").update(token).digest("hex");
    return CryptoJS.MD5(token).toString(CryptoJS.enc.Hex);
};

